import React from "react";
import { Box, Typography } from "@mui/material";
import user1 from "../../../assets/customerAssets/members/user1.png";
import user2 from "../../../assets/customerAssets/members/user2.png";
import user3 from "../../../assets/customerAssets/members/user3.png";
import user4 from "../../../assets/customerAssets/members/user4.png";

const dummyMembers = [user1, user2, user3, user4];

function getRandomMemberImg() {
  return dummyMembers[Math.round(Math.random() * 3)];
}

const Members = ({ members }) => {
  return (
    <Box className="clubMembers_wrapper club_members_club">
      <Typography component={"span"} className="head">
        Members
      </Typography>
      <Box className="members_div club_members_div">
        {members.length == 0 && (
          <Typography component={"span"} className="info">
            No members invited
          </Typography>
        )}
        {members.map((member) => {
          return (
            <Box className="member_details">
              <Box className="img_div">
                <img
                  src={
                    member?.invitedUserDetails?.profile_img ||
                    getRandomMemberImg()
                  }
                />
              </Box>
              <Typography component={"span"}>
                {member?.invitedUserDetails?.firstName +
                  " " +
                  member?.invitedUserDetails?.lastName || ""}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Members;
